import api from '../apis/api';
import { FETCH_GPU_CLASSES } from './types';
import getMessageFromApiError from '../util/getMessageFromApiError';
import { setErrorMessage } from './errorMessage';

// Renamed: Used by JobForm with Redux, uses selected_project as parameter
export const fetchProjectGpuClasses = (project_uuid) => async (dispatch) => {
  try {
    if (!project_uuid) {
      throw new Error('project_uuid is required');
    }
    const res = await api.get(`/project/${project_uuid}/gputypes`);
    dispatch({
      type: FETCH_GPU_CLASSES,
      payload: res.data,
    });
  } catch (error) {
    const message = getMessageFromApiError(error);
    dispatch(setErrorMessage(message));
    throw new Error(`API Error - ${message}`);
  }
};

// New: Used by GpuClassesContext, uses customer_uuid
export const fetchGpuClasses = async (customer_uuid) => {
  try {
    const res = await api.get(`/project/${customer_uuid}/gputypes`);
    return res.data;
  } catch (error) {
    const message = getMessageFromApiError(error);
    setErrorMessage(message);
    throw new Error(`API Error - ${message}`);
  }
};
